<template>
  <div v-if="initialData">
    <CustomizationsPage />
    <input
      id="hidden_tenant_name"
      type="hidden"
      :value="initialData.tenant.name"
    />
    <input
      id="hidden_tenant_support_email"
      type="hidden"
      :value="initialData.tenant.support_email"
    />
    <input
      id="hidden_tenant_customer_portal_url"
      type="hidden"
      :value="initialData.customer_portal_url"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";

import CustomizationsPage from "@/Customizations/CustomizationsPage.vue";

const initialData = ref<{
  tenant: Record<string, unknown>;
  customer_portal_url: string;
} | null>(null);

onMounted(async () => {
  const res = await fetch(`${window.location.pathname}/initial_page_data`, {
    method: "GET"
  });
  initialData.value = await res.json();
});
</script>
